import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent } from '../../ui/button/button.component';
import { ContentContainerComponent } from '../../ui/content-container/content-container.component';
import { PanelBodyComponent } from '../../ui/panel-body/panel-body.component';
import { PanelHostService } from '../../../services/panel-host.service';

@Component({
  selector: 'app-payment-importance-panel',
  imports: [TranslocoPipe, ButtonComponent, ContentContainerComponent, PanelBodyComponent],
  templateUrl: './payment-importance-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentImportancePanelComponent {
  private readonly panelHost = inject(PanelHostService);

  readonly bodyKeys = ['payment-importance.body.p1', 'payment-importance.body.p2'] as const;

  close(): void {
    this.panelHost.dismiss();
  }
}
